// In this folder, common variables can be accessed and edited in a single place.
export default {
  data() {
    return {
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'spare-part-logs',
      // Where data is fetched from
      endpoint: 'spareparts/logs',
      // The object key from the response object
      responseData: {
        single: 'logs',
        multiple: 'logs',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'spare-part-logs',
      responseFormat: 'logs',
      selectable: true,
      moduleContext: 'spare-part-logs',
    };
  },
};
